import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "../Router/constant";
import { loginPartnerAPI } from "../Services/authService";
import { toast } from "react-toastify";
import { NavLink } from "react-router";

export default function PartnerSignin() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate(RoutesPaths.DASHBOARD);
            return;
        }

        const rememberedEmail = localStorage.getItem("rememberMeEmail");
        const rememberedPassword = localStorage.getItem("rememberMePassword");
        if (rememberedEmail && rememberedPassword) {
            setEmail(rememberedEmail);
            setPassword(rememberedPassword);
            setRememberMe(true);
        }
    }, [navigate]);


    const handleLogin = async () => {
        setError("");
        if (!email || !password) {
            return setError("Please enter email and password.");
        }

        setLoading(true);
        try {
            const res = await loginPartnerAPI({ email, password });
            if (res.data?.data) {
                const token = res.data.data;

                if (rememberMe) {
                    localStorage.setItem("token", token);
                    localStorage.setItem("rememberMeEmail", email);
                    localStorage.setItem("rememberMePassword", password);
                } else {
                    localStorage.setItem("token", token);
                    localStorage.removeItem("rememberMeEmail");
                    localStorage.removeItem("rememberMePassword");
                }

                toast.success("Welcome back!");
                navigate(RoutesPaths.DASHBOARD);
            } else {
                setError("Invalid login response");
            }
        } catch (err) {
            setError(err.response?.data?.data?.message || "Login failed");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>
            <div className="row">
                <div className="col-md-4 authAlignmentSection authLeftSectionPartner">
                    <img src="/assets/img/quimeraLogo.svg" alt="Quimera Logo" className="quimeraLogo" />
                    <div className="authLeftSectionDetails">
                        <h3 className="m-0 partnerText">Vendor Portal</h3>
                        <p className="m-0 partnerText">Manage bookings, contracts, and services with ease.</p>
                    </div>
                    <img
                        src="/assets/img/partnerLogo.png"
                        alt="Vendor Dashboard"
                        className="img-fluid"
                    />
                </div>

                <div className="col-md-8 authAlignmentSection">
                    <div>
                        <img src="/assets/img/quimeraLogo.svg" alt="" className="mobileView" />
                    </div>

                    <div className="outerFormInnerDetails">
                        <div className="formInnerDetails">
                            <h6 className="m-0">Sign In</h6>
                            <p className="m-0"> Sign in to access your vendor dashboard.
                            </p>

                            {error && (
                                <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
                            )}

                            <div className="inputFieldSection">
                                <p className="m-0">Email</p>
                                <input
                                    type="text"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div className="inputFieldSection">
                                <p className="m-0">Password</p>
                                <div className="password-wrapper">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <img
                                        src={
                                            showPassword
                                                ? "/assets/img/eye-off.svg"
                                                : "/assets/img/eye.svg"
                                        }
                                        alt="toggle password"
                                        className="eye-icon"
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                </div>
                            </div>

                            <div className="rememberForgot">
                                <div className="rememberMe">
                                    <input
                                        type="checkbox"
                                        id="remeberme"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                    <label className="m-0" htmlFor="remeberme">
                                        Remember me
                                    </label>

                                </div>
                                <div>
                                    <NavLink
                                        to={RoutesPaths.RESET_PASSWORD}
                                        style={{ textDecoration: "none" }}
                                    >
                                        <p className="m-0 forgotText">Reset password</p>
                                    </NavLink>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="signInButtonPartner buttonFullWidth"
                                onClick={handleLogin}
                                disabled={loading}
                            >
                                {loading ? "Signing in..." : "Sign in"}
                            </button>
                        </div>
                    </div>

                    <div className="yearText">
                        <p className="m-0">© Quimera {new Date().getFullYear()}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
